module.exports = __webpack_public_path__ + "static/media/iconfinder_next_308956.ada93b48.svg";